import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { authenticationInitialState } from './constants';
import { AuthenticationState } from './types';

const authenticationSlice = createSlice({
  name: 'authentication',
  initialState: authenticationInitialState,
  reducers: {
    setMustRefreshAuthentication: (state: AuthenticationState, action: PayloadAction<boolean>) => {
      state.mustRefreshAuthentication = action.payload;
    },
  },
});

export const { setMustRefreshAuthentication } = authenticationSlice.actions;

export default authenticationSlice.reducer;
